import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Root from '../pages/root';
import Dashboard from '../pages/dashboard';
import {
	AuthenticatedLayout,
	ErrorPage,
	Permissions,
	Platforms,
	ProtectedPage,
} from 'carrier-fe';

import CourseList from '../pages/course';
import CourseForm from '../pages/course/form';
import Course from '../pages/course/view';

import VenueList from '../pages/venue';
import VenueForm from '../pages/venue/form';
import Venue from '../pages/venue/view';

import EventList from '../pages/event';
import EventForm from '../pages/event/form';
import Event from '../pages/event/view';

import QuizList from '../pages/quiz';
import QuizForm from '../pages/quiz/form';
import Quiz from '../pages/quiz/view';
import EventComplete from '../pages/event/complete';
import StageForm from '../pages/course/stage/form';
import UserList from '../pages/users';
import User from '../pages/users/view';
import UserForm from '../pages/users/form';
import CompaniesList from '../pages/companies';
import Company from '../pages/companies/view';
import CompanyForm from '../pages/companies/form';
import CompanyMerge from '../pages/companies/merge';
import EmailTemplateList from '../pages/email';
import EmailTemplate from '../pages/email/edit';
import ReportingList from '../pages/reporting';
import TrainingReportList from '../pages/training-report';
import DocumentsList from '../pages/documents';
import ProductsList from '../pages/products';
import MediaPacksList from '../pages/media-packs';
import MediaPackForm from '../pages/media-packs/form';
import MediaPacksLayout from '../pages/media-packs/layout';
import CarouselSlidesList from '../pages/carousel-slides';
import CarouselSlideForm from '../pages/carousel-slides/form';
import CarouselSlidesLayout from '../pages/carousel-slides/layout';
import ClaimsList from '../pages/claims';
import ClaimView from '../pages/claims/view';
import ApplianceManagementList from '../pages/appliance-management';
import ApplianceForm from '../pages/appliance-management/form';
import ApplianceManagementLayout from '../pages/appliance-management/layout';

function Router() {
	return (
		<BrowserRouter>
			<Routes>
				<Route
					index
					path="/"
					element={<Root />}
				/>

				{/*
				 * TODO - FOLLOWING ROUTES NEED TO BE AUTH PROTECTED
				 *      - IS A TOKEN SET IN THE COOKIE?
				 *      - IS THAT TOKEN VALID (CHECK VIA THE SERVER?
				 *      - IF NOT -> LOGOUT AND REDIRECT TO LOGIN
				 */}
				<Route
					path="/"
					element={<AuthenticatedLayout platform={Platforms.ADMIN} />}
				>
					<Route
						index
						path="/dashboard"
						element={
							<ProtectedPage
								requiredPermissions={
									Permissions.ADMIN_PLATFORM_VIEW
								}
							>
								<Dashboard />
							</ProtectedPage>
						}
					/>

					<Route path="/training/course">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_TRAINING_COURSE_INDEX
									}
								>
									<CourseList />
								</ProtectedPage>
							}
						/>
						<Route
							path=":courseId"
							element={<Course />}
						/>
						<Route
							path="create"
							element={<CourseForm />}
						/>
						<Route
							path=":courseId/edit"
							element={<CourseForm />}
						/>
						<Route
							path=":courseId/stage"
							element={<StageForm />}
						/>
						<Route
							path=":courseId/stage/:courseStageId/edit"
							element={<StageForm />}
						/>
					</Route>

					<Route path="/training/venue">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_TRAINING_VENUE_INDEX
									}
								>
									<VenueList />
								</ProtectedPage>
							}
						/>
						<Route
							path=":venueId"
							element={<Venue />}
						/>
						<Route
							path="create"
							element={<VenueForm />}
						/>
						<Route
							path=":venueId/edit"
							element={<VenueForm />}
						/>
					</Route>

					<Route path="/training/event">
						<Route
							index
							element={<EventList />}
						/>
						<Route
							path=":eventId"
							element={<Event />}
						/>
						<Route
							path="create"
							element={<EventForm />}
						/>
						<Route
							path=":eventId/edit"
							element={<EventForm />}
						/>
						<Route
							path=":eventId/complete"
							element={<EventComplete />}
						/>
					</Route>

					<Route path="/training/quiz">
						<Route
							index
							element={<QuizList />}
						/>
						<Route
							path=":quizId"
							element={<Quiz />}
						/>
						<Route
							path="create"
							element={<QuizForm />}
						/>
						<Route
							path=":quizId/edit"
							element={<QuizForm />}
						/>
					</Route>

					<Route path="/user">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_USER_INDEX
									}
								>
									<UserList />
								</ProtectedPage>
							}
						/>
						<Route
							path=":userId"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_USER_SHOW
									}
								>
									<User />
								</ProtectedPage>
							}
						/>
						<Route
							path="create"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_USER_STORE
									}
								>
									<UserForm />
								</ProtectedPage>
							}
						/>
						<Route
							path=":userId/edit"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_USER_UPDATE
									}
								>
									<UserForm />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path="/companies">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_COMPANY_INDEX
									}
								>
									<CompaniesList />
								</ProtectedPage>
							}
						/>
						<Route
							path=":companyId"
							element={<Company />}
						/>
						<Route
							path="create"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_COMPANY_STORE
									}
								>
									<CompanyForm />
								</ProtectedPage>
							}
						/>
						<Route
							path="merge"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_COMPANY_MERGE
									}
								>
									<CompanyMerge />
								</ProtectedPage>
							}
						/>
						<Route
							path=":companyId"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_COMPANY_SHOW
									}
								>
									<Company />
								</ProtectedPage>
							}
						/>
						<Route
							path=":companyId/edit"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_COMPANY_UPDATE
									}
								>
									<CompanyForm />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path="/email-templates">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.NOTIFICATION_TEMPLATE_INDEX
									}
								>
									<EmailTemplateList />
								</ProtectedPage>
							}
						/>
						<Route
							path=":templateId"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.NOTIFICATION_TEMPLATE_UPDATE
									}
								>
									<EmailTemplate />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path="/reporting">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_REPORT_INDEX
									}
								>
									<ReportingList />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path="/training/report">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_INDIVIDUAL_TRAININGS_INDEX
									}
								>
									<TrainingReportList />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path='/documents'>
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.DOCUMENT_INDEX
									}
								>
									<DocumentsList />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path='/products'>
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.PRODUCT_INDEX
									}
								>
									<ProductsList />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route
						path='/media-packs'
						element={<MediaPacksLayout />}
					>
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_MEDIA_PACK_INDEX
									}
								>
									<MediaPacksList />
								</ProtectedPage>
							}
						/>
						<Route
							path="create"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_MEDIA_PACK_STORE
									}
								>
									<MediaPackForm />
								</ProtectedPage>
							}
						/>
						<Route
							path=":mediaPackId/edit"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_MEDIA_PACK_UPDATE
									}
								>
									<MediaPackForm />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route
						path='/carousel-slides'
						element={<CarouselSlidesLayout />}
					>
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_CAROUSEL_SLIDE_INDEX
									}
								>
									<CarouselSlidesList />
								</ProtectedPage>
							}
						/>
						<Route
							path="create"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_CAROUSEL_SLIDE_STORE
									}
								>
									<CarouselSlideForm />
								</ProtectedPage>
							}
						/>
						<Route
							path=":carouselSlideId/edit"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.ADMIN_CAROUSEL_SLIDE_UPDATE
									}
								>
									<CarouselSlideForm />
								</ProtectedPage>
							}
						/>
					</Route>

					{/*
					 * The Viessmann appliance catalogue (CUS-932 to CUS-936).
					 *
					 * Create is details-only and redirects to the edit page on success: the API has no way
					 * to attach a serial prefix or a warranty option to an appliance that does not exist
					 * yet, and no bulk endpoint, so the child sections only become live once there is an id
					 * to hang them off.
					 */}
					<Route
						path="/appliance-management"
						element={<ApplianceManagementLayout />}
					>
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.VIESSMANN_ADMIN_APPLIANCE_INDEX
									}
								>
									<ApplianceManagementList />
								</ProtectedPage>
							}
						/>
						<Route
							path="create"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.VIESSMANN_ADMIN_APPLIANCE_STORE
									}
								>
									<ApplianceForm />
								</ProtectedPage>
							}
						/>
						<Route
							path=":applianceId"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.VIESSMANN_ADMIN_APPLIANCE_SHOW
									}
								>
									<ApplianceForm />
								</ProtectedPage>
							}
						/>
						<Route
							path=":applianceId/edit"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.VIESSMANN_ADMIN_APPLIANCE_UPDATE
									}
								>
									<ApplianceForm />
								</ProtectedPage>
							}
						/>
					</Route>

					<Route path="/claims">
						<Route
							index
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.TOSHIBA_ADMIN_CLAIM_INDEX
									}
								>
									<ClaimsList />
								</ProtectedPage>
							}
						/>
						<Route
							path=":claimId"
							element={
								<ProtectedPage
									requiredPermissions={
										Permissions.TOSHIBA_ADMIN_CLAIM_SHOW
									}
								>
									<ClaimView />
								</ProtectedPage>
							}
						/>
					</Route>
				</Route>

				<Route
					path="*"
					element={<ErrorPage />}
				/>
			</Routes>
		</BrowserRouter>
	);
}

export default Router;
